/**
 * Honeypot - a hidden anti-bot input field.
 *
 * Real users cannot see or focus this input (positioned off-screen,
 * tabIndex=-1, aria-hidden, autocomplete=off). Bots that autofill every
 * input in a form will populate it; the backend silently drops any
 * submission where this field is non-empty.
 *
 * Usage:
 *   const [honeypot, setHoneypot] = useState("");
 *   ...
 *   <Honeypot value={honeypot} onChange={setHoneypot} />
 *   // On submit, send `website_url: honeypot` (or the multipart field name)
 */
export default function Honeypot({ value, onChange, name = "website_url" }) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        left: "-9999px",
        top: "auto",
        width: "1px",
        height: "1px",
        overflow: "hidden",
      }}
    >
      <label htmlFor={`hp-${name}`}>Website (leave blank)</label>
      <input
        id={`hp-${name}`}
        type="text"
        name={name}
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={`honeypot-${name}`}
      />
    </div>
  );
}
